<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section class="position-relative"
         style="{style(block, 'background-image: url(&#39;../../assets/img/curved-images/curved14.jpg&#39;); background-size:cover;')}">
  <span class="mask bg-gradient-dark"></span>
  <div class="container position-relative mb-4">
    <!-- <div class="row"> -->
    <!--   <div class="col-md-8 mx-auto text-center mb-5"> -->
    <!--     <div class="icon icon-shape bg-gradient-info shadow text-center mb-3"> -->
    <!--       <i class="fas fa-users"></i> -->
    <!--     </div> -->
    <!--     <h3 class="text-white z-index-1 position-relative">The Executive Team</h3> -->
    <!--     <p class="lead text-white opacity-6">There’s nothing I really wanted to do in life that I wasn’t able to get good at. That’s my skill.</p> -->
    <!--   </div> -->
    <!-- </div> -->
    <div class="row">
      {#each blocklist(block, 'members') as member}
      <div class="col-lg-6 col-12 mb-5">
        <div class="card card-profile overflow-hidden">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-12 pe-lg-0">
              <a href="javascript:;">
                <div class="p-3 pe-md-0">
                  <img class="w-100 border-radius-md" src="{image(member, 'picture', [300, 300])}">
                </div>
              </a>
            </div>
            <div class="col-lg-8 col-md-6 col-12 ps-lg-0 my-auto">
              <div class="card-body">
                <h5 class="mb-0">{text(member, 'name')}</h5>
                <h6 class="text-info">{text(member, 'title')}</h6>
                <p class="mb-0">{text(member, 'description')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/each}
    </div>
  </div>
  <div class="position-absolute w-100 z-index-1 bottom-0">
    <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 40" preserveAspectRatio="none" shape-rendering="auto">
      <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
      </defs>
      <g class="moving-waves">
        <use xlink:href="#gentle-wave" x="48" y="-1" fill="rgba(255,255,255,0.40"></use>
        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.35)"></use>
        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.25)"></use>
        <use xlink:href="#gentle-wave" x="48" y="8" fill="rgba(255,255,255,0.20)"></use>
        <use xlink:href="#gentle-wave" x="48" y="13" fill="rgba(255,255,255,0.15)"></use>
        <use xlink:href="#gentle-wave" x="48" y="16" fill="rgba(255,255,255,0.95"></use>
      </g>
    </svg>
  </div>
</section>
